import { Injectable } from '@angular/core';
import { TrxService } from '~services/trx/trx.service';
import { createFeatureFlagClient, FeatureFlagUser, FeatureFlagClient } from '@zip/feature-flag-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  featureFlagClient: FeatureFlagClient;
  private _isV2Enabled = false;

  constructor(private trxService: TrxService) {}

  async init(user: FeatureFlagUser) {
    try {
      this.featureFlagClient = createFeatureFlagClient(this.trxService.analytics, {
        deploymentKey: environment.zipFeatureFlag.deploymentKey,
        environment: environment.zipFeatureFlag.env,
      });

      await this.featureFlagClient.start(user);
    } catch (error) {
      console.error('Failed to initialise feature flag', error);
    }
  }

  isFeatureEnabled(key: string) {
    try {
      const featureFlag = this.featureFlagClient.getFeatureFlag(key);
      return !!featureFlag;
    } catch (error) {
      console.error('Failed to retrieve feature flag', error);
      return false;
    }
  }

  get isV2Enabled() {
    return this._isV2Enabled;
  }

  initGiftCardsV2Feature() {
    const isV2Session = sessionStorage.getItem('loyalty-gift-cards-v2');
    if (isV2Session) {
      this._isV2Enabled = isV2Session === 'true';
    } else {
      this._isV2Enabled = this.isFeatureEnabled('loyalty-gift-cards-v2');
      sessionStorage.setItem('loyalty-gift-cards-v2', this._isV2Enabled.toString());
    }
  }
}
